<!--横向滑动包裹类  -->
<template>
    <div class="CrossSlip">
        <div  :class="{'overFlowBox':true,'innerWidth':crossType=='inner'}">
            <div class="scrollView scrollView--fullWidth scrollView--x">
                <div :class="{'scrollView-scroller':true,'scrollView-scroller-min':crossType==='inner'}">
                    <div class="scrollView-inner">
             <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import {mapState, mapActions, mapMutations} from "vuex";
    export default {
        name: 'CrossSlip',
        components: {

        },
        props: {
            crossType:{
                type:String,
                default:'default'  //inner内嵌  //
            }

        },
        data () {
            return {

            }

        },
        methods: {

        }
    }
</script>
<style lang="less" scoped>
    .CrossSlip{
    .innerWidth{
        width: 9.2rem;
    }

    }

</style>
